<template>
  <!-- 公告栏看板 -->
  <div class="mainWarp">
    <div class="dataWarp" id="dataWarp" @scroll.prevent>
      <div class="ulDiv" id="ulDiv" @scroll.prevent>
        <div class="dataItem" @scroll.prevent v-for="item in dataList" :key="item.id">
          <span class="title" @click="Rowclicklu" v-if="item.alarmLevel == '报警'"
            style="color: #ff0000; margin-left: 5px; margin-right: 5px">
            <img src="../Call-the-police.png" alt="" style="width: 20px; height: 20px" />
            <a-tooltip>
              <template slot="title" class="dataWrapB">{{ item.title }}</template>
              {{ item.title }}
            </a-tooltip>
          </span>
          <span class="title" @click="Rowclicklu" v-if="item.alarmLevel !== '报警'"
            style="color: #ffcc66; margin-left: 5px; margin-right: 5px">
            <img src="../warning.png" alt="" style="width: 20px; height: 20px" />
            <a-tooltip>
              <template slot="title" class="dataWrapB">{{ item.title }}</template>
              {{ item.title }}
            </a-tooltip>
          </span>
        </div>
      </div>
      <div id="ulDiv2"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BulletinBoard',
  components: {},
  data () {
    return {
      dataList: [],
      speed: 100,
      colee: '',
      colee1: '',
      colee2: ''
    }
  },
  created () { },
  mounted () {
    this.getKanbanData()
  },
  methods: {
    Rowclicklu () {
      this.$router.push({ path: '/remote-water/user/alarm-data' })
    },
    getKanbanData () {
      this.$http
        .get('/pipe-network/remote_water_meter_alarm_messages/list', {
          params: {
            sysTab: 0,
            isDispose: 0
          }
        })
        .then((res) => {
          res.data.map((item) => {
            this.dataList.push({
              title: item.msgAddress + item.flowMeterNo + item.alarmIndex + item.alarmType + item.collectTime,
              content: item.flowMeterNo,
              stateType: item.alarmContent,
              alarmLevel: item.alarmLevel
            })
          })
          if (this.dataList.length >= 3) {
            this.$nextTick(() => {
              this.goScroll()
            })
          }
        })
    },
    goScroll () {
      const vm = this
      this.colee2 = document.getElementById('ulDiv2')
      this.colee1 = document.getElementById('ulDiv')
      this.colee = document.getElementById('dataWarp')
      this.colee2.innerHTML = this.colee1.innerHTML // 克隆colee1为colee2

      let MyMar1 = setInterval(this.Marquee1, this.speed) // 设置定时器
      // 鼠标移上时清除定时器达到滚动停止的目的

      this.colee.onmouseover = function () {
        clearInterval(MyMar1)
      }

      this.colee.onmouseout = function () {
        MyMar1 = setInterval(() => {
          vm.Marquee1()
        }, vm.speed)
      }

      this.$once('hook:beforeDestroy', () => {
        clearInterval(MyMar1)
        MyMar1 = null
      })
    },
    Marquee1 () {
      // 当滚动至colee1与colee2交界时
      if (this.colee2.offsetTop - this.colee.scrollTop <= 0) {
        this.colee.scrollTop -= this.colee1.offsetHeight + 20 // colee跳到最顶端
      } else {
        this.colee.scrollTop++
      }
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  display: block;
  overflow: hidden;
  /*内容超出后隐藏*/
  text-overflow: ellipsis;
  /* 超出内容显示为省略号 */
  white-space: nowrap;
  /* 文本不进行换行 */
  width: 360px;
}

.mainWarp {
  height: 55px;
  width: 100%;
  overflow-x: hidden;
  // top: 80px;
  // left: 34px;
  // position: absolute;
  z-index: 99;
  border-radius: 10px;
  background-size: contain;

  .img-title {
    display: flex;
    align-items: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 16px;
    color: #101010;
    letter-spacing: 0.63px;
    font-weight: 600;
    height: 30px;

    .DataTitle {
      width: 4px;
      height: 18px;
      margin-right: 10px;
      border-radius: 3px;
    }
  }

  .dataWarp {
    height: 60px;
    width: 100%;
    // padding: 0 20px;
    overflow-x: hidden;
    z-index: 100;

    // background: rgba(0, 32, 54, 0.75);
    .dataItem {
      width: 100%;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      // padding: 0 16px;
      // margin-top: 20px;
      .dataItemTitle {
        font-family: MicrosoftYaHeiSemibold;
        font-size: 14px;
        font-weight: 600;
        width: 120px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .dataItemTime {
        font-family: MicrosoftYaHei;
        font-size: 13px;
        color: rgba(9, 9, 9, 0.75);
        text-align: right;
        font-weight: 400;
      }
    }
  }
}

::-webkit-scrollbar {
  width: 0 !important;
}

::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
</style>
